export default `
    <link href='/snippets-style/welcome/games.css' rel='stylesheet' />
  <div class="wl-section--wrap wl-section--wrap__blue">
    <div class="wl-section--head">Try our Bests</div>
    <div class="wl-section--subHead">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc interdum ornare id blandit</div>
    <div class="wl-section--games">
      <div class="wl-game--wrap  wl-game--wrap__jackpot">
        <a href="#" class="wl-game"></a>
      </div>
      <div class="wl-game--wrap  wl-game--wrap__burning">
        <a href="#" class="wl-game">
          <div class="wl-game--title">Game title</div>
          <div class="wl-game--info">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
          <div class="wl-game--btn">PLAY NOW</div>
        </a>
      </div>
      <div class="wl-game--wrap wl-game--wrap__supreme">
        <a href="#" class="wl-game">
          <div class="wl-game--title">Game title</div>
          <div class="wl-game--info">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
          <div class="wl-game--btn">PLAY NOW</div>
        </a>
      </div>
    </div>
  </div>
  `;
